function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9 .667a8.333 8.333 0 100 16.667A8.333 8.333 0 009 .667zm0 15A6.667 6.667 0 119 2.334a6.667 6.667 0 010 13.333zm2.133-9.242l.442.442a.4.4 0 010 .583L10.033 9l1.542 1.55a.4.4 0 010 .584l-.442.441a.4.4 0 01-.583 0L9 10.034l-1.55 1.541a.4.4 0 01-.583 0l-.442-.441a.4.4 0 010-.584L7.967 9 6.425 7.45a.4.4 0 010-.583l.442-.442a.4.4 0 01.583 0L9 7.967l1.55-1.542a.4.4 0 01.583 0z",
  fill: "#FA5252"
});

var SvgClearCircle = function SvgClearCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    fill: "none"
  }, props), _ref);
};

export default SvgClearCircle;